import { useLayoutEffect } from "react";

import { rewriteMsalPathStyleOAuthHash } from "../helpers/msalPathStyleHash";

/**
 * HashRouter re-inserts "/" after "#", undoing the early boot rewrite.
 * Re-apply in useLayoutEffect so MSAL's handleRedirectPromise (useEffect)
 * still sees "#state=..." / "#code=...".
 */
export const MsalPathStyleHashFix = () => {
  useLayoutEffect(() => {
    rewriteMsalPathStyleOAuthHash();
  }, []);
  return null;
};
